import { render, staticRenderFns } from "./ItemAutoCreate.vue?vue&type=template&id=1b9cafff&scoped=true&"
import script from "./ItemAutoCreate.vue?vue&type=script&lang=js&"
export * from "./ItemAutoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9cafff",
  null
  
)

export default component.exports